import React, { Component } from 'react';

export default class NewsFeeds extends Component {
    render () {
        return<div>
            Here will be some NewsFeeds
        </div>
    }
}